import React, { Component } from 'react';
import axios from 'axios';
import HashtagCreate from './components/HashtagCreate';
import HashtagDelete from './components/HashtagDelete';



export default class HashtagPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            models: [],
            model: null,
        };
        this.getAllHashtag = this.getAllHashtag.bind(this);
        this.createOrUpdateHashtag = this.createOrUpdateHashtag.bind(this);
        this.hashtagDelete = this.hashtagDelete.bind(this);
    }

    componentWillMount() {
        this.getAllHashtag();
    }

    getAllHashtag() {
        let url = global.config.apiDomain + "/rest/hashtag/getAllHashtag"
        axios.post(url)
            .then(res => {
                this.setState({
                    models: res.data.models
                })
            })
    }
    createOrUpdateHashtag(event) {
        let index = event.target.name;
        let model = null;

        if (index === "-1") {
            model = {
                id: '',
                description: '',
            }
        } else {
            model = this.state.models[index];
        }  
        this.setState({
            model: model
        })

    }
    hashtagDelete(event) {
        let index = event.target.name;
        let model = this.state.models[index];
        this.setState({
            model: model
        })
    }

    render() {
        const { models, model } = this.state;

        return (
            <>
             <HashtagCreate
                    model={model}
                    resetList={this.getAllHashtag}
                ></HashtagCreate>
                <HashtagDelete
                    model={model}
                    resetList={this.getAllHashtag}
                ></HashtagDelete>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí HashTag</h1>
                        <button
                            className="btn btn-info mb-1"
                            data-toggle="modal"
                            data-target="#modalCreate"
                            name="-1"
                            onClick={this.createOrUpdateHashtag}
                        >Tạo mới HashTag
                        </button>
                        <table className="table table-hover">
                            <thead>
                                <tr className="text-center">
                                    <th className="align-middle" scope="col">ID</th>
                                    <th className="align-middle" scope="col">Ngày tạo</th>
                                    <th className="align-middle" scope="col">Nội dung</th>
                                    <th className="align-middle" scope="col">Tuỳ chỉnh</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    models && models.map((item, index) => {
                                        return (
                                            <tr>
                                                <td className="align-middle text-center" scope="col">{item.id}</td>
                                                <td className="align-middle text-center" scope="col">{new Date(item.addTime).toLocaleString()}</td>
                                                <td className="align-middle text-center" scope="col">{item.description}</td>
                                                <td className="align-middle text-center" scope="col">
                                                    {
                                                        item.deleted ? (
                                                            <button
                                                                className="btn btn-info"
                                                                onClick={this.hashtagDelete}
                                                                name={index}
                                                                data-toggle="modal"
                                                                data-target="#modalDelete"
                                                            >
                                                                Mở lại
                                                            </button>
                                                        ) : (
                                                            <>
                                                                <button
                                                                    className="btn btn-success"
                                                                    onClick={this.createOrUpdateHashtag}
                                                                    name={index}
                                                                    data-toggle="modal"
                                                                    data-target="#modalCreate"
                                                                >
                                                                    Sửa
                                                                </button>&emsp;
                                                                <button
                                                                    className="btn btn-warning"
                                                                    onClick={this.hashtagDelete}
                                                                    name={index}
                                                                    data-toggle="modal"
                                                                    data-target="#modalDelete"
                                                                >
                                                                    Ẩn
                                                                </button>
                                                            </>
                                                        )
                                                    }
                                

                                                </td>
                                            </tr>
                                        )
                                    })

                                }

                            </tbody>
                        </table>
                    </div>
                </div>

            </>
        );
    }
}